module.exports = __webpack_public_path__ + "static/media/zgoda_na_przekazanie_dokumentacji_medycznej.6c0ad9d7.pdf";